import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'burger-menu-icon',
  templateUrl: './burger-menu-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BurgerMenuIconComponent {}
